// Where a brand-new account lands. Someone who came through an invite link goes
// straight to Home, where the pending invite is consumed and they join: the
// first-run questions would only sit between them and the group they came for.
export function postSignupPath() {
  try {
    if (localStorage.getItem('pendingInviteCode')) return '/'
  } catch { /* private mode */ }
  return '/welcome'
}
